export const appConfig = {
  environment: "prod",
  sendGridApiKey:
    "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",
  API: {
    URL: "https://api.atyabtabkha.com",
    KEY: "c21f3a7d-d1d6-4a2c-bdc3-c609e14c75d9",
  },
  firebaseConfig: {
    apiKey: "AIzaSyDTDLGA-7IKk2Qef5bIUXrdnbjxv7Q71y4",
    authDomain: "atyabtabkha-altis.firebaseapp.com",
    projectId: "atyabtabkha-altis",
    storageBucket: "atyabtabkha-altis.appspot.com",
    messagingSenderId: "607604247437",
    appId: "1:607604247437:web:57f3fb1af232de8bcc8bc4",
    measurementId: "G-TZ6PXGT4Z9",
  },
  appCheckKey: "6LeLWOUqAAAAAExH4YuRwXL6y_39Pm3yF-12M98W",
};
